export const processConfiguration = {
  name: "Name",
  defaultValue: "Standardwert",
  type: "Typ",
  image: "Bild",
  changeImage: "Bild ändern",
  deleteImage: "Bild entfernen",
  description: "Beschreibung",
  flowTypes: {
    PROCESS_ENGINE: "Automation",
    CSV_IMPORTER: "Import",
    CUSTOMIZING: "Customization",
    STANDARD: "Standard"
  }
};
